import { render, staticRenderFns } from "./ClinicDoctors.vue?vue&type=template&id=1de195c2&scoped=true&"
import script from "./ClinicDoctors.vue?vue&type=script&lang=js&"
export * from "./ClinicDoctors.vue?vue&type=script&lang=js&"
import style0 from "./ClinicDoctors.vue?vue&type=style&index=0&id=1de195c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de195c2",
  null
  
)

export default component.exports